<template>
  <s-page class="max-w-2xl mx-auto" v-if="isDataLoaded">
    <waste-list />
    <modal-waste />
    <modal-delete-waste />
  </s-page>
</template>

<script>
import SPage from '@/components/SPage'
import WasteList from '@/components/WasteList'
import ModalWaste from '@/components/ModalWaste'
import ModalDeleteWaste from '@/components/ModalDeleteWaste'
import { mapState } from 'vuex'

export default {
  name: 'Waste',
  components: {
    WasteList,
    ModalWaste,
    ModalDeleteWaste,
    SPage
  },
  computed: {
    ...mapState('config', ['isDataLoaded'])
  }
}
</script>
